import { Route } from 'react-router-dom';
import h from 'react-hyperscript';

import { Header, Footer } from '../../components';

const DefaultLayout = ({ component, ...rest }) =>
  h(Route, {
    ...rest,
    render: matchProps => h('layout-default', [h(Header), h(component, { ...matchProps }), h(Footer)]),
  });

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/layouts/Default/Default.js